import request from '@/utils/request'

let SalestargetApi = {
  /*销售自定义列表*/
  list(data) {
    return request._post('/shop/plus.salestarget.salestarget/list', data);
  },
    /*获取当前列表*/
    getCurrentList(data) {
      return request._post('/shop/plus.salestarget.salestarget/getCurrentList', data);
    },
  /*获取销售自定义设置详情*/
  settingDetail(data){
    return request._get('/shop/plus.salestarget.salestarget/setting',data);
  },
  /*设置销售自定义设置*/
  editSetting(data){
    return request._post('/shop/plus.salestarget.salestarget/setting',data);
  },
   /*删除目标自定义*/
  del(data){
    return request._post('/shop/plus.salestarget.salestarget/del',data);
  },

}
export default SalestargetApi;



// WEBPACK FOOTER //
// ./src/api/salestarget.js